var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 mb-3"},[_vm._v(_vm._s(_vm.labelTitle))]),_c('base-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"id","fixed-header":""}},'base-table',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }